<!-- 课程详情 -->
<template>
  <div class="subject-index-box" :style="{ marginBottom: (hideOrderBtns ? '10px' : '75px') }">
    <SubjectDetail :subject="subject" />
    <!-- 弹幕 -->
    <BulletScreen />
    <!-- 未购买则显示按钮区 -->
    <div class="btn-box">
      <div class="home" @click="backHome">
        <img :src="require('@/assets/icons/home2.png')" alt="">
        <p>首页</p>
      </div>
      <template v-if="hideOrderBtns">
        <div v-if="subject.buyStatus == 'own_subject'" class="learn" @click="toLearn">
          马上学习
        </div>
        <div class="share" :class="[!user.isDistributor && subject.pinkInfo && (subject.pinkInfo.status !== 'success') ? 'grey-info' : 'origin-info']" @click="inviteFriends">
          {{user.isDistributor? '推广赚佣金' : '赚奖学金'}}
        </div>
      </template>
      <template v-else>
        <div v-if="!invitationCode && !user.isDistributor" class="full" :class="{ disabled: ordering }" @click="fullBuy">
          <p class="price">￥ {{ subject.fullPrice }}</p>
          <p class="alone_buy_btn">单独全价购</p>
        </div>
        <!-- 课程可拼团则显示拼团按钮 -->
        <div class="group" @click="pinkBuy" v-if="(subject.isGroup || invitationCode) && !user.isDistributor">
          <p class="price">￥ {{ subject.myCoupon ? subject.myCoupon.coupon.groupPrice : subject.groupPrice }} <span v-if="subject.myCoupon">(已减{{ subject.myCoupon.coupon.offAmount }})</span></p>
          <p v-if="subject.groupPrice > 0"><span>发起{{ subject.groupNum || 1 }}人团</span></p>
          <p v-else>免费领取</p>
          <p class="limit">限时抢</p>
        </div>
        <div class="group" v-if="user.isDistributor" @click="distributeBuy">
          <p class="price">¥ {{ subject.groupPrice }}</p>
          <p>{{ subject.groupPrice > 0 ? '立即购买' : '免费领取'}}</p>
        </div>
      </template>
    </div>
    <!-- 经销商邀请弹框 -->
    <SharePopup :show="showDistributorInvite" :text="subject ? subject.shareTitle : ''" @close="showDistributorInvite=false" />
    <!-- 邀请弹框 -->
    <SharePopup :show="showInvite" @close="showInvite=false" />
    <van-action-sheet v-model="showSheet" class="pay_box" title="课程详情"  @close="cancelConfirm()" :close-on-click-overlay="false">
      <!-- <div class="title">
        <span class="text">商品详情</span>
        <div class="close_btn" @close.capture="cancelConfirm(false)">
            <img :src="require('@/assets/icons/close.png')" />
        </div>
      </div> -->

      <div class="shop_tab tab">
        <div class="img fl">
          <img :src="require('@/assets/icons/goods.png')" />
        </div>
        <div class="text fl">课程名称</div>
        <div class="name fr">{{ subject.title }}</div>
      </div>
      <div class="buyway_tab tab">
        <div class="img fl">
          <img :src="require('@/assets/icons/buyway.png')" />
        </div>
        <div class="text fl">购买方式</div>
        <div class="name fr">{{ orderType === 'pink_buy' || orderType === 'distribute_buy' ? '拼团购买' : '单独全价购' }}</div>
      </div>
      <div class="coupon_tab tab" v-if="orderType === 'pink_buy' && myCoupons.length > 0" @click="showCoupon = !showCoupon">
        <div class="img fl">
          <img :src="require('@/assets/icons/coupon.png')" />
        </div>
        <div class="text fl">优惠券抵扣</div>
        <div class="name fr">-¥ {{currentCoupon.coupon.offAmount}}</div>
        <van-icon name="arrow" />
      </div>
      <div class="coupon_list" v-if="orderType === 'pink_buy' && myCoupons.length > 0" v-show="showCoupon">
        <div class="coupon_item" :class="item.id === currentCoupon.id ? 'active' : ''" v-for="(item, index) in myCoupons" :key="index" @click="selectCoupon(item)">
          <van-icon :name="item.id === currentCoupon.id ? 'passed' : 'circle'" />
          省{{item.coupon.offAmount}}元：{{item.coupon.title}}
        </div>
        <div class="coupon_item" :class="!currentCoupon.id ? 'active' : ''" @click="selectCoupon(false)">
          <van-icon :name="!currentCoupon.id ? 'passed' : 'circle'" />
          不使用优惠券
        </div>
      </div>
      <div class="pay_tab tab">
        <div class="img fl">
          <img :src="require('@/assets/icons/pay.png')" />
        </div>
        <div class="text fl">支付总额</div>
        <div class="name fr"><span>￥</span><span class="num">{{ orderType === 'pink_buy' || orderType === 'distribute_buy' ? currentCoupon.coupon.groupPrice : subject.fullPrice }}</span></div>
      </div>
      <button class="sure_pay" @click="sendOrder">确定支付</button>
    </van-action-sheet>
  </div>
</template>
<script>
import wx from 'weixin-js-sdk'
import { createOrder, getOrderInfo, getSubjectInfo } from './query.gql'
import SubjectDetail from './detail'
import BulletScreen from '@/components/BulletScreen'
import SharePopup from '@/components/SharePopup'
export default {
  name: 'Subject',
  data() {
    return {
      user: '',
      showDistributorInvite: false, // 经销商邀请好友
      showInvite: false, // 邀请好友
      active: 0,
      order: '', // 订单
      subject: '', // 课程
      myCoupons: [], // 用户优惠券
      currentCoupon: {},
      showCoupon: false,
      pinkId: null, // 拼团 id
      showSheet: false, // 是否显示购买窗
      ordering: false, // 下单中
      invitationCode: '',
      scene: '',
      orderType: 'full_buy' // full_buy: 直接购买; pink_buy: 拼团购买; distribute_buy: 分销购
    }
  },
  components: {
    SubjectDetail,
    BulletScreen,
    SharePopup
  },
  computed: {
    hideOrderBtns: function() {
      // 有订单在支付中和已支付
      const ordered = this.subject && this.subject.orderInfo && ['wait_pay', 'paid'].includes(this.subject.orderInfo.status)
      // 有拼团正在
      // const pinked = this.subject && this.subject.pinkInfo && this.subject.pinkInfo.status === 'success'
      return ordered
    }
  },
  async mounted() {
    await this.weixinAuth()
    const { id, invitationCode, scene } = this.$route.query
    this.invitationCode = invitationCode
    this.scene = scene
    if (id) {
      console.log('课程详情页 ID = ', id)
      this.loadData()

      // const self = this
      // self.$zhuge.track('查看课程详情', {
      //   '课程名称': self.subject.title,
      //   '拼团价': self.subject.groupPrice
      // })
    } else {
      this.$toast.fail('无课程详情')
    }
  },
  methods: {
    backHome() {
      const self = this

      if (this.subject.isSingle) {
        this.$router.push({
          name: 'classroom',
          query: {
            isSingle: self.subject.isSingle
          }
        })
      } else {
        this.$router.push({
          name: 'home',
          query: {
            invitationCode: self.invitationCode
          }
        })
      }
      // self.$zhuge.track('返回首页', {
      //   '课程名称': self.subject.title
      // })
    },
    toLearn() {
      this.$router.push({
        name: 'learn',
        query: { id: this.subject.id }
      })
    },
    // 邀请好友
    inviteFriends() {
      if (this.user.isDistributor) {
        this.showDistributorInvite = true
      } else {
        if (this.subject.pinkInfo && (this.subject.pinkInfo.status !== 'success')) {
          this.$toast.fail('还未拼团成功，拼团成功后可赚取奖学金')
        } else {
          this.showInvite = true
        }
      }
    },
    setShare() {
      const self = this
      let num = Math.floor(Math.random() * 11) + 10
      let shareLink = ''
      if (self.user.isDistributor) {
        shareLink = `${window.location.origin}/#/subject?id=${self.subject.id}&invitationCode=${self.user.invitationCode}`
      } else {
        if (self.hideOrderBtns) {
          shareLink = `${window.location.origin}/?#/invite/${self.subject.id}?invitationCode=${self.user.invitationCode}`
        } else {
          shareLink = `${window.location.origin}/#/subject?id=${self.subject.id}`
        }
      }
      self.wechatShare({
        title: `${num}人正在拼→${self.subject.shareTitle}`,
        imgUrl: self.subject.smallLogoImg,
        desc: self.subject.shareContent,
        link: shareLink
      })
    },
    loadData() {
      // 请求数据
      const self = this
      self.$toast.loading({
        mask: true,
        duration: 0,
        message: '加载中'
      })
      let id = parseInt(self.$route.query.id)
      self.$apollo.query({
        query: getSubjectInfo,
        variables: { id },
        fetchPolicy: 'no-cache'
      }).then(res => {
        self.user = res.data.profile
        self.subject = res.data.subject
        self.myCoupons = res.data.userCoupons
        self.currentCoupon = {
          coupon: {
            offAmount: 0,
            groupPrice: self.subject.groupPrice
          }
        }
        if (!self.subject.orderInfo && !self.user.isDistributor && !self.invitationCode) {
          // 未购课才显示优惠券信息
          let offAmount = 0
          self.myCoupons.forEach(item => {
            switch (item.coupon.types) {
              case 'money_off':
                item.coupon.offAmount = parseFloat(item.coupon.moneyOffAmount).toFixed(2)
                break
              case 'discount':
                item.coupon.offAmount = (parseFloat(self.subject.groupPrice) * (1 - parseFloat(item.coupon.discount) / 100)).toFixed(2)
                break
            }
            item.coupon.groupPrice = (parseFloat(self.subject.groupPrice) - item.coupon.offAmount).toFixed(2)
            if (parseFloat(item.coupon.offAmount) > offAmount) {
              offAmount = parseFloat(item.coupon.offAmount)
              self.subject.myCoupon = item
              self.currentCoupon = item
            }
          })
        }
        self.setShare()
        self.$toast.clear()
      }).catch(err => {
        console.error('page：subject/index。请求getSubjectInfo报错', err)
        self.$toast.clear()
        self.$toast.fail('加载数据出错')
      })
    },
    selectCoupon(item) {
      if (item) {
        this.currentCoupon = item
      } else {
        this.currentCoupon = {
          coupon: {
            offAmount: 0,
            groupPrice: this.subject.groupPrice
          }
        }
      }
    },
    // 单独购买
    fullBuy() {
      this.wechatPay().then(() => {
        this.showSheet = true
        this.orderType = 'full_buy'
      })
    },
    // 拼团购买
    pinkBuy() {
      this.wechatPay().then(() => {
        this.showSheet = true
        this.orderType = 'pink_buy'
      })
    },
    // 分销购买
    distributeBuy() {
      this.wechatPay().then(() => {
        this.showSheet = true
        this.orderType = 'distribute_buy'
      })
    },
    // 取消确认
    cancelConfirm() {
      const self = this
      console.log('showSheet', self.showSheet)
      if (self.showSheet) {
        self.$dialog.confirm({
          message: '确认取消付款？',
          confirmButtonText: '继续支付',
          confirmButtonColor: '#ff4e00',
          cancelButtonText: '取消支付'
        }).then(() => {
          self.showSheet = true
        }).catch(() => {
          console.log('取消支付')
          self.showSheet = false
        })
      }
    },
    // 下单
    sendOrder() {
      const self = this
      self.$toast({
        type: 'loading',
        mask: true,
        duration: 0,
        message: '提交中'
      })
      let variables = {
        subjectId: self.subject.id,
        types: self.orderType,
        scene: self.scene
      }
      if (self.invitationCode && self.orderType === 'pink_buy') {
        Object.assign(variables, {
          invitationCode: self.invitationCode
        })
      }
      if (self.currentCoupon.id && self.orderType !== 'distribute_buy') {
        Object.assign(variables, {
          userCouponId: self.currentCoupon.id
        })
      }
      if (self.orderType === 'distribute_buy') {
        let invitationCode = ''
        if (self.user.isDistributor) {
          invitationCode = self.user.invitationCode
        }
        if (self.invitationCode) {
          invitationCode = self.invitationCode
        }
        Object.assign(variables, {
          invitationCode
        })
      }
      console.log('创建订单参数', variables)
      self.$apollo.mutate({
        mutation: createOrder,
        variables
      }).then(res => {
        let result = res.data.createOrderMutation
        console.log('创建订单结果', res)
        if (self.orderType === 'pink_buy' && result.order.pink) {
          self.pinkId = result.order.pink.id
        }
        self.order = self.$clone(result.order)
        self.showSheet = false
        self.ordering = false
        if (result.order.totalFee > 0) {
          wx.chooseWXPay({
            timestamp: result.timeStamp,
            nonceStr: result.nonceStr,
            package: result.package,
            signType: result.signType,
            paySign: result.paySign,
            success() {
              self.$toast.clear()
              self.polling(result.order.tranNo)

              // self.$zhuge.track('支付成功', {
              //   '课程名称': self.subject.title,
              //   '课程ID': self.subject.id,
              //   '拼团ID': self.pinkId
              // })
            },
            cancel() {
              self.$toast.clear()
              self.$toast('支付已取消')
              self.setShare()
            },
            fail() {
              self.$toast.clear()
              self.$toast.fail('支付失败')
              self.setShare()
            }
          })
        } else {
          self.$toast.clear()
          self.polling(result.order.tranNo)
        }
      }).catch(err => {
        console.error('page: subject/index。请求createOrder报错', err)
        self.$toast.fail(err.graphQLErrors[0].message || '下单失败')
        self.setShare()
      })
    },
    // 轮询
    polling(tranNo) {
      const self = this
      self.$toast({
        type: 'loading',
        mask: true,
        duration: 0,
        message: '支付中'
      })
      let pollTimes = self.$consts.POLLING_TIMES || 5 // 默认轮询五次
      let timer = setInterval(() => {
        pollTimes -= 1
        if (pollTimes >= 0) {
          self.$apollo.query({
            query: getOrderInfo,
            variables: { tranNo },
            fetchPolicy: 'no-cache'
          }).then(res => {
            console.log('轮询结果', res)
            if (res.data.order.status === 'paid') {
              self.$toast.clear()
              clearInterval(timer)
              if (res.data.order.types === 'full_buy' || res.data.order.types === 'distribute_buy') {
                self.$router.replace({
                  name: 'classroom',
                  query: {
                    isSingle: self.subject.isSingle
                  }
                })
              } else {
                self.$router.replace({
                  name: 'groupInvite',
                  params: { id: self.pinkId }
                })
              }
            }
          }).catch(err => {
            console.error('page: subject/index。（轮询）请求getOrderInfo报错', err)
          })
        } else {
          // 超过5次轮询没有结果怎么办？？
          self.$toast.clear()
          self.setShare()
        }
      }, self.$consts.POLLING_INTERVAL || 2000)
    }
  }
}
</script>
<style lang="scss">
.subject-index-box {
  min-height: 100vh;
  background: #e6e6e6;

  .grey-info {
    background-color: #999;
  }

  .origin-info {
    background-color: #ff4e00;
  }

  .btn-box {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    overflow: hidden;
    box-sizing: border-box;
    color: #fff;
    display: flex;
    .home{
      width: 50px;
      background: #fff;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      img{
        width: 20px;
        height: 20px;
        display: block;
      }
      p{
        color: #333;
        padding-top: 5px;
        font-size: 10px;
      }
    }
    .full {
      flex: 2;
      padding: 8px 0;
      background-color: #ff7639;
      text-align: center;
      span{
        font-size: 12px;
      }
    }
    .learn{
      flex: 2;
      padding: 8px 0;
      background-color: #ff7639;
      text-align: center;
      line-height: 37px;
    }
    .share{
      flex: 3;
      padding: 8px 0;
      box-sizing: border-box;
      text-align: center;
      line-height: 37px;
    }
    .group {
      flex: 3;
      padding: 8px 0;
      background-color: #ff4e00;
      box-sizing: border-box;
      text-align: center;
      overflow: hidden;
      .limit {
        color: #fa512d;
        background-color: #ff0;
        position: absolute;
        width: 120px;
        height: 48px;
        line-height: 80px;
        font-size: 18px;
        top: -15px;
        right: -50px;
        font-weight: bold;
        text-align: center;
        transform: rotate(40deg);
      }
      span{
        font-size: 12px;
      }
    }
    .price {
      font-size: 20px;
      font-weight: bold;
    }
  }

  .pay_box {
    font-size: 15.36px;
    border-radius: 9.6px 9.6px 0 0;
    .fl {
      float: left;
    }
    .fr {
      float: right;
    }
    img {
      width: 100%;
    }
    .tab {
      overflow: hidden;
      height: 38.3906px;
      line-height: 38.3906px;
      padding: 0 26.88px;
      border-bottom: 0.46875px solid #f7f7f7;
      position: relative;
      display: flex;
      align-items: center;
      .img {
        padding-top: 9.6px;
        padding-right: 12.48px;
        width: 18.7188px;
      }
      .text {
        font-size: 17.28px;
        color: #333;
        flex: 1;
      }
      .name {
        font-size: 14.4px;
        color: #666;
        padding-right: 4.8px;
      }
    }
    .coupon_list{
      padding: 20px 60px;
      border-bottom: 0.46875px solid #f7f7f7;
      .coupon_item{
        line-height: 40px;
        display: flex;
        align-items: center;
        .van-icon{
          margin-right: 10px;
        }
        &.active{
          color: #ff6000;
        }
      }
    }
    .sure_pay {
      display: block;
      margin: 0 auto 22.56px;
      width: 92%;
      height: 45.1094px;
      border-radius: 22.56px;
      line-height: 45.12px;
      font-size: 18.72px;
      color: #fff;
      text-align: center;
      background-color: #ff6000;
      margin: 15.36px 14.4062px 24px;
      border: unset;
    }
  }
}
</style>
